import React from 'react'
import { useTranslation } from 'react-i18next';

function Services() {
    const { t } = useTranslation();

    const services = [
        {
            icon: 'bi-box-seam',
            title: t('servicesTitle'),
            desc: t('servicesDesc1'),
            points: [
                t('servicesPoint1'),
                t('servicesPoint2'),
                t('servicesPoint3'),
                t('servicesPoint4'),
            ],
        },
        {
            icon: 'bi-truck',
            title: t('servicesTitle2'),
            desc: t('servicesDesc2'),
            points: [
                t('servicesPoint5'),
                t('servicesPoint6'),
                t('servicesPoint7'),
                t('servicesPoint8'),
            ],
        },

        {
            icon: 'bi-building',
            title: t('servicesTitle3'),
            desc: t('servicesDesc3'),
            points: [
                t('servicesPoint9'),
                t('servicesPoint10'),
                t('servicesPoint11'),
                t('servicesPoint12'),
            ],
        },
        {
            icon: 'bi-shield-slash-fill',
            title: t('servicesTitle4'),
            desc: t('servicesDesc4'),
            points: [
                t('servicesPoint13'),
                t('servicesPoint14'),
                t('servicesPoint15'),
                t('servicesPoint16'),
            ],
        },
    ];

    return (
        <section
            className="services-section py-5 position-relative"
            style={{
                marginTop: "-250px",
                zIndex: 10,
            }}
        >
            <div className="container">
                <div className="row g-3">
                    {services.map((service, idx) => (
                        <div key={idx} className="col-md-4">
                            <div
                                className="card h-100 border-0 shadow-sm rounded-4 p-4 bg-white text-dark transition"
                                data-aos="zoom-in"
                                data-aos-delay={idx * 300}
                            >
                                <div className="fs-2 text-primary mb-3">
                                    <h5 className="fw-semibold">
                                        <i className={`bi ${service.icon}`}></i> {service.title}
                                    </h5>
                                </div>

                                <p className="text-muted">{service.desc}</p>

                                <ul className="ps-3">
                                    {service.points.map((point, i) => (
                                        <li key={i}>{point}</li>
                                    ))}
                                </ul>

                                <button className="btn btn-sm btn-primary mt-3" onClick={() => window.location.href = '/services'}>
                                    {t('learnMore')}
                                </button>
                            </div>

                        </div>
                    ))}
                </div>
            </div>
            <style>
                {`
                    .card:hover {
                    transform: translateY(-10px);
                    background-color: #091a3a;
                    box-shadow: 0 1rem 3rem rgba(0,0,0,.175) !important;
                    color: white;
                    transition: all 0.1s ease;
                    }
                    .card:hover .btn {
                    background-color: white !important;
                    color: #084298 !important;
                    }

                 `}
            </style>


        </section>
    );
}


export default Services